var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCourseMetaLanguage = function SvgIconCourseMetaLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1L1 3V36L19 47L37 36V3L19 1Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H17",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10V12",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C14.5367 13.9106 13.6485 15.6516 12.4218 17.0535C11.1951 18.4554 9.67178 19.4705 8 20",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C9.52947 13.9106 10.5446 15.6516 11.9465 17.0535C13.3484 18.4554 15.0894 19.4705 17 20",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33L24.954 24.4122C24.9958 24.2911 25.0704 24.1867 25.168 24.1131C25.2655 24.0395 25.3813 24 25.5 24C25.6187 24 25.7345 24.0395 25.832 24.1131C25.9296 24.1867 26.0042 24.2911 26.046 24.4122L29 33",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H28",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7H6.25C5.55964 7 5 7.55964 5 8.25V20.75C5 21.4404 5.55964 22 6.25 22H18.75C19.4404 22 20 21.4404 20 20.75V8.25C20 7.55964 19.4404 7 18.75 7Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 21H31.75C32.0815 21 32.3995 21.1229 32.6339 21.3417C32.8683 21.5605 33 21.8572 33 22.1667V33.8333C33 34.1428 32.8683 34.4395 32.6339 34.6583C32.3995 34.8771 32.0815 35 31.75 35H19.25C18.9185 35 18.6005 34.8771 18.3661 34.6583C18.1317 34.4395 18 34.1428 18 33.8333V25.0833",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35L14 32.5L12 30",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26C7 27.5913 7.61458 29.1174 8.70854 30.2426C9.80251 31.3679 11.2862 32 12.8333 32H14",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8L24 10.5L26 13",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31 17C31 15.1435 30.3854 13.363 29.2915 12.0503C28.1975 10.7375 26.7138 10 25.1667 10H24",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconCourseMetaLanguage;